module.exports = __webpack_public_path__ + "assets/img/tx102bt.6b8a653a.jpg";